module.exports = __webpack_public_path__ + "static/media/company.35ad68fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/company.jpg
// module id = 468
// module chunks = 17